import React from 'react';
import { Grid } from 'semantic-ui-react';
import { VariantConsumer, MenuConsumer } from '../../../../FoodMenu.context';
import MenuUtil from '../../../../utils/menu';
import ScheduleAvailability from '../../navigation/ScheduleAvailability';
import { categoryVarianComponentMap } from '../index';
export default function CategoryContainer(_ref) {
  var scheduleId = _ref.scheduleId;
  return /*#__PURE__*/React.createElement(MenuConsumer, null, function (_ref2) {
    var schedules = _ref2.schedules,
      categories = _ref2.categories,
      disableScheduleAvailability = _ref2.disableScheduleAvailability;
    var schedule = MenuUtil.getScheduleById(schedules, scheduleId);
    var scheduleCategoryIds = schedule.categories,
      availableDays = schedule.availableDays,
      startTime = schedule.startTime,
      endTime = schedule.endTime;
    var preserveScheduleCategoriesOrder = true;
    var scheduleCategories = MenuUtil.getScheduleCategories(scheduleCategoryIds, categories, preserveScheduleCategoriesOrder);
    return /*#__PURE__*/React.createElement(VariantConsumer, null, function (_ref3) {
      var categoryDisplay = _ref3.categoryDisplay;
      var CategoryComponent = categoryVarianComponentMap[categoryDisplay];
      var categoryComponents = scheduleCategories.map(function (category) {
        return /*#__PURE__*/React.createElement(CategoryComponent, {
          category: category
          // eslint-disable-next-line no-underscore-dangle
          ,

          key: category._id,
          scheduleCategories: scheduleCategories
        });
      });
      return /*#__PURE__*/React.createElement("div", null, !disableScheduleAvailability && /*#__PURE__*/React.createElement(ScheduleAvailability, {
        availableDays: availableDays,
        startTime: startTime,
        endTime: endTime
      }), categoryDisplay === 'Column' ? /*#__PURE__*/React.createElement(Grid, {
        stackable: true,
        columns: 2
      }, categoryComponents) : categoryComponents);
    });
  });
}